import React from "react";
import { css, useTheme } from "@emotion/react";

type Props = {
    children: React.ReactNode,
    className?: string,
    imageWidth: number,
    carouselCellSpacing: number,
};

const CarouselWrapper: React.FC<Props> = ({
    children,
    className,
    imageWidth,
    carouselCellSpacing,
}) => {
    const theme = useTheme();

    const style = css`
        margin: 0 auto;
        
        ${theme.breakpoints.up("lg")} {
            width: ${(imageWidth * 3) + (carouselCellSpacing * 2)}px;
        }

        ${theme.breakpoints.down("md")} {
            width: ${imageWidth}px;
            margin-bottom: 40px;
        }
    `;

    return (
        <div css={style} className={className}>
            {children}
        </div>
    );
};

export default CarouselWrapper;
